import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { ref, onValue } from "firebase/database";
import "./ChatList.css";

export default function ChatList({ onSelect, selectedChatId, search }) {

  const [chats, setChats] = useState([]);

  useEffect(() => {

    const chatsRef = ref(db, "chats");

    const unsubscribe = onValue(chatsRef, (snapshot) => {

      const data = snapshot.val();

      if (!data) {
        setChats([]);
        return;
      }

      const lista = Object.keys(data).map((wa_id) => {
        const historial = data[wa_id]?.historial;
        let ultimoMensaje = { texto: "", timestamp: 0 };

        if (historial) {
          Object.values(historial).forEach((msg) => {
            const ts = msg.timestamp ? new Date(msg.timestamp).getTime() : 0;
            if (ts >= ultimoMensaje.timestamp) {
              const texto = msg.mensaje_usuario || msg.mensaje_bot || msg.mensaje_panel || "";
              ultimoMensaje = { texto, timestamp: ts, rawTimestamp: msg.timestamp };
            }
          });
        }

        return { id: wa_id, ultimoMensaje };
      });

      lista.sort((a, b) => b.ultimoMensaje.timestamp - a.ultimoMensaje.timestamp);
      setChats(lista);

    });

    return () => unsubscribe();

  }, []);

  const getLastMessagePreview = (chatId) => {
    const chat = chats.find((c) => c.id === chatId);
    return chat?.ultimoMensaje?.texto || "Sin mensajes";
  };

  const getLastMessageTime = (chatId) => {
    const chat = chats.find((c) => c.id === chatId);
    if (!chat?.ultimoMensaje?.timestamp) return "";
    return new Date(chat.ultimoMensaje.rawTimestamp).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const chatsFiltrados = chats.filter((chat) =>
    chat.id.toLowerCase().includes(search.toLowerCase())
  );

  return (

    <div className="chat-list">

      <div className="chat-list__header">
        <h3>Chats</h3>
        <span className="chat-list__count">
          {chatsFiltrados.length}
        </span>
      </div>

      <div className="chat-list__items custom-scroll">

        {chatsFiltrados.map((chat) => (

          <div
            key={chat.id}
            className={`chat-list__item ${
              selectedChatId === chat.id ? "chat-list__item--active" : ""
            }`}
            onClick={() => onSelect(chat.id)}
          >

            <div className="chat-item__avatar">
              <img src="/logo192.png" alt="Tresatec" className="chat-item__avatar-img" />
            </div>

            <div className="chat-item__info">

              <div className="chat-item__name">
                {chat.id}
              </div>

              <div className="chat-item__preview">
                {getLastMessagePreview(chat.id)}
              </div>

            </div>

            <div className="chat-item__meta">

              <div className="chat-item__time">
                {getLastMessageTime(chat.id)}
              </div>

            </div>

          </div>

        ))}

      </div>

    </div>

  );
}